/**
 * Conta Google usada so para importar perfis. Nao loga no sistema.
 */
export const IMPORTER_ROLE = "GMAIL_MANAGER";

/**
 * Tira as contas importadoras da Lista de Usuarios.
 *
 * Elas nao servem para acessar o sistema, so para trazer os perfis do Google,
 * e enchiam a lista de quem administra usuarios de verdade. Continuam
 * acessiveis pelo filtro Nivel de Acesso > Conta Google (importador).
 */
export const hideImporterAccounts = <T extends { userType?: string }>(
  users: T[],
  roleFilter: string
): T[] => {
  if (roleFilter === IMPORTER_ROLE) {
    return users;
  }

  return users.filter((user) => user.userType !== IMPORTER_ROLE);
};
